import { styles as MS } from "pages/student/games/Memorama/styles/MemoramaSettings.styles"

export const styles = {
  contanier: MS.contanier,
  ...MS,
  dialogHeader: (theme) => ({
    backgroundColor: theme.palette.background.default,
  }),
}
